<template>
  <BaseModal :is-open="isOpen" @update:is-open="$emit('update:isOpen', $event)">
    <p class="mb-4 text-xl font-semibold text-center text-terracota-dark">Order another box</p>
    <p class="text-center text-off-black">
      Do you want to unpause your subscription or order a one-off box?
    </p>
    <div class="flex flex-col mt-6 space-y-4">
      <button
        class="primary-cta"
        :disabled="unpausePlanMutation.isPending.value"
        @click="unpausePlan"
      >
        <BaseLoadingIcon v-if="unpausePlanMutation.isPending.value" class="size-6" />
        <span v-else>Unpause subscription</span>
      </button>
      <router-link :to="{ name: 'one-off-product-box' }" class="secondary-cta text-center">
        Place a one-off order
      </router-link>
    </div>
  </BaseModal>
</template>

<script setup lang="ts">
  import useActivateSubscription from '@/api/mutations/pensa/activateSubscription';
  import useSubscriptionStore from '@/stores/subscriptionStore';
  import { useRouter } from 'vue-router';

  interface Props {
    isOpen: boolean;
  }

  interface Emits {
    (e: 'update:isOpen', value: boolean): void;
  }

  defineProps<Props>();
  defineEmits<Emits>();

  const router = useRouter();
  const unpausePlanMutation = useActivateSubscription();
  const subscriptionStore = useSubscriptionStore();

  const unpausePlan = () => {
    if (subscriptionStore.selectedSubscription) {
      unpausePlanMutation.mutate(subscriptionStore.selectedSubscription.id, {
        onSuccess: () => {
          router.push({ name: 'upcoming-orders' });
        },
      });
    }
  };
</script>
